import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/bjarne-intervju.jpeg";

function IntervjuBjarneSorum() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.interviewBjarne.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.interviewBjarne.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/intervju-bjarne-sorum"
        />
      </Helmet>
      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-4">
            {i18next.t("pages.articles.list.interviewBjarne.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.interviewBjarne.description")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.interviewBjarne.date")}
          </p>
        </div>
        <img
          src={article_img}
          className="w-full md:w-2/5 object-cover"
          alt={i18next.t("pages.articles.list.interviewBjarne.imageAlt")}
        />
      </div>
      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <h2 className="text-3xl font-bold mb-2">
              {i18next.t("pages.articles.list.interviewBjarne.sections.fromProduction.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.interviewBjarne.sections.fromProduction.content1")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.fromProduction.content2")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.fromProduction.content3")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewBjarne.sections.norwegianExcellence.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.interviewBjarne.sections.norwegianExcellence.content1")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.norwegianExcellence.content2")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.norwegianExcellence.content3")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewBjarne.sections.leadingMarket.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.interviewBjarne.sections.leadingMarket.content1")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.leadingMarket.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewBjarne.sections.culture.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.interviewBjarne.sections.culture.content1")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.culture.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-2">
              {i18next.t("pages.articles.list.interviewBjarne.sections.future.title")}
            </h2>
            <p>
              {i18next.t("pages.articles.list.interviewBjarne.sections.future.content1")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.future.content2")}
            </p>
            <p className="mt-4">
              {i18next.t("pages.articles.list.interviewBjarne.sections.future.content3")}
            </p>

            <p className="mt-8">
              {i18next.t("pages.articles.list.interviewBjarne.sections.conclusion.content")}{" "}
              <a href="/skjema/kontakt-oss" className="font-bold underline hover:text-contrast-ink">
                {i18next.t("pages.articles.list.interviewBjarne.sections.conclusion.cta")}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntervjuBjarneSorum;


